import React from 'react';
import { cn } from '../../../lib/utils';

export interface TaskySkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  shape?: 'rect' | 'circle' | 'text';
}

export const TaskySkeleton: React.FC<TaskySkeletonProps> = ({
  className,
  shape = 'rect',
  ...rest
}) => (
  <div
    {...rest}
    aria-hidden
    className={cn(
      'bg-gray-200 animate-shimmer',
      shape === 'rect' && 'rounded-tasky-sm',
      shape === 'circle' && 'rounded-full',
      shape === 'text' && 'rounded h-4',
      className,
    )}
  />
);
